import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { can_visit } from "../../helpers";

const autoResize = (el) => {
  if (el) {
    el.style.height = "auto";
    el.style.height = el.scrollHeight+2 + "px";
  }
};

const AuditReporteditNote = forwardRef(({ initialData={}, noteEditMode=false, setHasChanges=()=>{} }, ref) => {
  const [postVisitData, setPostVisitData] = useState(initialData);

  // Refs
  const reasonRef = useRef();
  const historyRef = useRef();
  const assessmentRefs = useRef([]);
  const reviewRef = useRef();
  const physicalRef = useRef();

  useEffect(() => {
    autoResize(reasonRef.current);
    autoResize(historyRef.current);
    autoResize(reviewRef.current);
    autoResize(physicalRef.current);
    assessmentRefs.current.forEach((ref) => autoResize(ref));
  }, [noteEditMode]);

  useImperativeHandle(ref, () => ({
    getCleanedEditNoteData: () => {
      return {
        ...postVisitData,
        reason_for_visit: (postVisitData.reason_for_visit || [])
          .join("\n")
          .split('\n')
          .map(line => line.trim())
          .filter(Boolean),
        review_of_systems: (postVisitData.review_of_systems || [])
          .join("\n")
          .split('\n')
          .map(line => line.trim())
          .filter(Boolean),
        physical_exam: (postVisitData.physical_exam || [])
          .join("\n")
          .split('\n')
          .map(line => line.trim())
          .filter(Boolean),
      };
    },
  }));

  return (
    <>
      {!can_visit('ehr_veradigm') && (
        <>
          {/* REASON FOR VISIT */}
          <div>
            <p className="chart_inline_copy"><b>REASON FOR VISIT:</b></p>
            <textarea
              ref={reasonRef}
              className="docpro_note_edit_textarea"
              value={(postVisitData.reason_for_visit || []).join('\n')}
              onChange={(e) => {
                autoResize(e.target);
                setPostVisitData((prev) => ({
                  ...prev,
                  reason_for_visit: e.target.value.split('\n'),
                }));
                setHasChanges(true);
              }}
            />
          </div><br />
        </>
      )}

      {/* HISTORY OF PRESENT ILLNESS */}
      <div>
        <p className="chart_inline_copy"><b>HISTORY OF PRESENT ILLNESS:</b></p>
        <textarea
          ref={historyRef}
          className="docpro_note_edit_textarea"
          value={
            Array.isArray(postVisitData.history_of_present_illness)
              ? postVisitData.history_of_present_illness.join('\n')
              : postVisitData.history_of_present_illness || ''
          }
          onChange={(e) => {
            const value = e.target.value;
            setPostVisitData((prev) => ({
              ...prev,
              history_of_present_illness: Array.isArray(prev.history_of_present_illness)
                ? value.split('\n')
                : value,
            }));
            setHasChanges(true);
          }}
        />
      </div><br />

      {/* REVIEW OF SYSTEMS */}
      <div>
        <p className="chart_inline_copy"><b>REVIEW OF SYSTEMS:</b></p>
        <textarea
          ref={reviewRef}
          className="docpro_note_edit_textarea"
          value={(postVisitData.review_of_systems || []).join('\n')}
          onChange={(e) => {
            autoResize(e.target);
            setPostVisitData((prev) => ({
              ...prev,
              review_of_systems: e.target.value.split('\n'),
            }));
            setHasChanges(true);
          }}
        />
      </div><br />

      {/* PHYSICAL EXAM */}
      <div>
        <p className="chart_inline_copy"><b>PHYSICAL EXAM:</b></p>
        <textarea
          ref={physicalRef}
          className="docpro_note_edit_textarea"
          value={(postVisitData.physical_exam || []).join('\n')}
          onChange={(e) => {
            autoResize(e.target);
            setPostVisitData((prev) => ({
              ...prev,
              physical_exam: e.target.value.split('\n'),
            }));
            setHasChanges(true);
          }}
        />
      </div><br />

      {/* DIAGNOSIS CODE - Read-only */}
      <div>
        <p className="chart_inline_copy"><b>DIAGNOSIS CODE:</b></p>
        {Array.isArray(postVisitData.icd_codes) && postVisitData.icd_codes.length > 0 ? (
          <ol style={{ margin: 0 }}>
            {postVisitData.icd_codes.map((code, i) => (
              <li key={i}>
                {code?.description} <b className="mr-2">(<span>{code?.code}</span>)</b>
              </li>
            ))}
          </ol>
        ) : (
          <p className="docpro_ternary_color"><i>None</i></p>
        )}
      </div><br />

      {/* ASSESSMENT/PLAN - Only assessment_plan editable */}
      <div>
        <p className="chart_inline_copy"><b>ASSESSMENT/PLAN:</b></p>
        {Array.isArray(postVisitData.assessment) && postVisitData.assessment.length > 0 ? (
          <ul>
            {postVisitData.assessment.map((item, i) => (
              <li key={i} className="mb-3">
                <b className="mr-2">{item?.icd_code}</b><br />
                <textarea
                  ref={(el) => (assessmentRefs.current[i] = el)}
                  className="docpro_note_edit_textarea"
                  value={item.assessment_plan || ''}
                  onChange={(e) => {
                    const updated = [...postVisitData.assessment];
                    updated[i].assessment_plan = e.target.value;
                    setPostVisitData((prev) => ({
                      ...prev,
                      assessment: updated,
                    }));
                    setHasChanges(true);
                  }}
                />
              </li>
            ))}
          </ul>
        ) : (
          <p className="docpro_ternary_color"><i>None</i></p>
        )}
      </div>
    </>
  );
});

export default AuditReporteditNote;
